export enum PrerequisiteType {
  FINISHED = 'FINISHED',
  PARALLEL = 'PARALLEL'
}

export enum PrerequisiteExistenceStatus {
  EXISTING = 'EXISTING',
  DISCONTINUED = 'DISCONTINUED'
}

export const DISCONTINUED_PREREQUISITE_VALUE = -1;
